export default __webpack_public_path__ + "static/media/404_imp.8db7a8a5.png";